import { ChangeDetectionStrategy, Component } from '@angular/core';
import { MatDialogClose } from '@angular/material/dialog';
import { MatIcon } from '@angular/material/icon';

@Component({
  selector: 'shared-modal-header',
  imports: [MatIcon, MatDialogClose],
  templateUrl: './modal-header.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ModalHeaderComponent {}
